import React from "react";
import { useNavigate } from "react-router";
import { FormProvider, useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import Box from "@mui/material/Box";

import Button from "components/Button";
import { FormInput } from "components/FormInput";

import { useAppDispatch, useAppSelector } from "store/hooks";
import { resetPassword } from "store/features/authSlice";

import {
  ResetPasswordFormValues,
  ResetPasswordValidationSchema,
} from "./validation";
import { routes } from "routes/routes";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface ResetPasswordFormProps {
  email: string | null;
  token: string | null;
}

const ResetPasswordForm: React.FC<ResetPasswordFormProps> = (props) => {
  const { email, token } = props;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.auth.isLoading);

  const methods = useForm<ResetPasswordFormValues>({
    mode: "onSubmit",
    resolver: yupResolver(ResetPasswordValidationSchema),
  });

  const onSubmit = () => {
    if (email && token) {
      methods.handleSubmit(async (values: ResetPasswordFormValues) => {
        analytics().sendEvent(AnalyticsEvents.reset_password_save);

        await dispatch(
          resetPassword({
            email,
            resetCode: token,
            newPassword: values.password,
          })
        ).unwrap();
        navigate(routes.auth);
      })();
    }
  };

  return (
    <Box>
      <FormProvider {...methods}>
        <FormInput
          title="Новий пароль"
          name="password"
          fullWidth
          type="password"
        />
        <FormInput
          title="Підтвердіть новий пароль"
          name="confirmPassword"
          fullWidth
          type="password"
        />
      </FormProvider>

      <Button
        sx={{ mb: 2 }}
        variant="contained"
        color="primary"
        fullWidth
        onClick={onSubmit}
        loading={isLoading}
      >
        Зберегти
      </Button>
    </Box>
  );
};

export default ResetPasswordForm;
